<div class="tab-padding-fdic-img">
    <img [src]="fdicImgLink" role="img" [alt]="fdicImgAltTxt" [attr.aria-label]="fdicImgAltTxt">
</div>